export const ACTIONS = {
	MAINTENANCE: {
		value: 'MAINTENANCE',
		label: 'Maintenance'
	},
	CHANGE: {
		value: 'CHANGE',
		label: 'Change'
	},
	PROVIDE: {
		value: 'PROVIDE',
		label: 'Provide'
	}
};

export const priorities = [
	{
		value: 0,
		label: '0'
	},
	{
		value: 1,
		label: '1'
	},
	{
		value: 2,
		label: '2'
	}
];
